import { render, staticRenderFns } from "./VaultSettingsNav.vue?vue&type=template&id=17a564e9"
import script from "./VaultSettingsNav.vue?vue&type=script&lang=js"
export * from "./VaultSettingsNav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports